const zIndex = {
  toast: 13000,
  preview: 12500,
  tooltip: 12000,
  pageLoading: 11500,
  popup: 11000,
  dropdown: 9500,
  modal: 9000,
  widget: 8800,
  settingDim: 8501,
  dim: 8500,
  detailModal: 500,
  contentModal: 400,
  chartTooltip: 300,
  innerResizebar: 500,
  layoutHeader: 100,
  mentionPortal: 60,
  resizeHandler: 55,
  sidebar: 50,
  tableHeader: 5,
  hidden: -100,
};

export default zIndex;
